<template>
  <div class="mt-4 p-3 border rounded-4 bg-light">
    <h4 class="mb-3">Configuración LastApp</h4>
    <div class="mb-3">
      <label for="token" class="form-label">Token:<span class="text-danger">*</span></label>
      <input
        id="token"
        type="text"
        class="form-control"
        v-model="localToken"
        @input="onTokenChange"
        maxlength="200"
        placeholder="" />
    </div>
    <div class="mb-3">
      <label for="locationId" class="form-label">Location ID:<span class="text-danger">*</span></label>
      <input
        id="locationId"
        type="text"
        class="form-control"
        v-model="localLocationId"
        @input="onLocationIdChange"
        maxlength="100"
        placeholder="" />
    </div>
    <div class="mb-3">
      <label for="catalogId" class="form-label">Catalog ID:<span class="text-danger">*</span></label>
      <input
        id="catalogId"
        type="text"
        class="form-control"
        v-model="localCatalogId"
        @input="onCatalogIdChange"
        maxlength="100"
        placeholder="" />
    </div>
    <div class="mb-3">
      <label for="brandId" class="form-label">Brand ID:<span class="text-danger">*</span></label>
      <input
        id="brandId"
        type="text"
        class="form-control"
        v-model="localBrandId"
        @input="onBrandIdChange"
        maxlength="100"
        placeholder="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormLastAppComponent',
  props: {
    token: { type: String, default: '' },
    locationId: { type: String, default: '' },
    catalogId: { type: String, default: '' },
    brandId: { type: String, default: '' }
  },
  data() {
    return {
      localToken: this.token,
      localLocationId: this.locationId,
      localCatalogId: this.catalogId,
      localBrandId: this.brandId
    };
  },
  watch: {
    token(val) {
      this.localToken = val;
    },
    locationId(val) {
      this.localLocationId = val;
    },
    catalogId(val) {
      this.localCatalogId = val;
    },
    brandId(val) {
      this.localBrandId = val;
    }
  },
  methods: {
    onTokenChange() {
      this.$emit('update:token', this.localToken);
    },
    onLocationIdChange() {
      this.$emit('update:locationId', this.localLocationId);
    },
    onCatalogIdChange() {
      this.$emit('update:catalogId', this.localCatalogId);
    },
    onBrandIdChange() {
      this.$emit('update:brandId', this.localBrandId);
    }
  }
};
</script>

<style scoped>

</style>
